import cx from 'classnames';
import { useHistory } from "react-router-dom";
import { FC, FormEventHandler as FEH, useState } from "react";

import * as Meta from 'meta';
import { ROUTE } from "route";
import { setAgreePrivate, gaEvent } from "utils";
import { Footer, Header, Modal, Notice } from "components";

import style from "./style.module.scss";

export const PrivatePage: FC = () => {
  const history = useHistory();
  const [isShowNotice, setIsShowNotice] = useState(false);

  const url = new window.URLSearchParams(location.search.slice(1));

  // 判斷是導去掃描頁還是導去中獎/非中獎頁的判斷要寫在這裡
  const handleAgree: FEH<HTMLFormElement> = e => {
    e.preventDefault();
    setAgreePrivate();
    const search = url.get('qrcode') ? `?qrcode=${url.get('qrcode')}`: '';
    history.push(`${ROUTE.SCAN}${search}`);
  };

  const handleShowNotice = (isShow: boolean) => {
    setIsShowNotice(isShow);
  };

  return (
    <div className="wrapper">
      {Meta.loadCSS(['login', 'notice'])}
      {Meta.loadJS('main-0625')}
      {Meta.ga("隱私權確認頁")}
      <Header />
      <div className="main">
        <form className="login inner" onSubmit={handleAgree}>
          <div className="login_icheck"><img src="/resources/html/images/login/check.png" /></div>
          <div className="login_checktext">爽啤QRcode抽獎活動</div>
          <div className="login_in">
            <input className="login_check" type="checkbox" name="check" required id="check" />
            <span>
              我已充分閱讀
              <label htmlFor="check" className={cx("login_notice", style.label)} onClick={setIsShowNotice.bind(null, true)}>
                活動辦法及注意事項與隱私權保護政策
              </label>
              ，並同意以上條款之約定，提供個資作為活動參加使用。
            </span>
          </div>
          <div className="login_btbox">
            <button onClick={gaEvent.bind(null, '隱私權確認', '確認送出')}>開始抽獎</button>
          </div>
        </form>
        <img className="login_left" src="/resources/html/images/intro/intro_left.png" />
        <img className="login_right" src="/resources/html/images/intro/intro_right.png" />
        <div className="other o3 ml"><img src="/resources/html/images/op1.png" /></div>
        <div className="other o4 mr"><img src="/resources/html/images/op3.png" /></div>
        <div className="fwave fw1 ml"><img src="/resources/html/images/login/wave01.png" /></div>
        <div className="fwave fw2 mr"><img src="/resources/html/images/login/wave02.png" /></div>
        <div className="fwave fw3 ml"><img src="/resources/html/images/login/wave03.png" /></div>
        <div className="fwave fw4 mr"><img src="/resources/html/images/login/wave04.png" /></div>
      </div>
      <Footer />
      <div className="scroll_top"><span>TOP</span></div>
      {isShowNotice &&
          <Modal onClose={handleShowNotice}><Notice /></Modal>
      }
    </div>
  );
};
